(function() {
  function setMode(mode) {
    if (document.body.getAttribute('data-card-mode') === mode) return; // Don't re-run if already set
    document.body.setAttribute('data-card-mode', mode);
    document.querySelectorAll('.switch-view-container span[data-mode]').forEach(s => s.classList.remove('active'));
    document.querySelector('.switch-view-container span[data-mode="' + mode + '"]').classList.add('active');
    // Update all Swipers
    document.querySelectorAll('.card-wrapper').forEach(card => {
      if (card.swiperInstance && typeof card.swiperInstance.slideTo === 'function') {
        card.swiperInstance.slideTo(window.getCardStartIndex(), 0);
      }
    });
  }

  window.getCardMode = function() {
    return document.body.getAttribute('data-card-mode') || 'produit';
  };
  window.getCardStartIndex = function() {
    // Fixed: produit should show index 0, modele should show index 1
    return window.getCardMode() === 'produit' ? 0 : 1;
  };

  document.addEventListener('DOMContentLoaded', function() {
    if (!document.body.hasAttribute('data-card-mode')) {
      setMode('produit');
    }
    document.querySelectorAll('.switch-view-container span[data-mode]').forEach(span => {
      span.addEventListener('click', function() {
        setMode(this.getAttribute('data-mode'));
      });
    });
    
    // Initialize facets container height
    updateFacetsContainerHeight();
    
    // Auto-open size filter accordions on page load
    autoOpenActiveSizeFilters();
    
    // Sync size filter active states on page load
    syncSizeFilterActiveStates();
    
    // Listen for product grid updates to maintain overlay state
    document.addEventListener('product-grid-updated', function() {
      // Check if mobile facets are open and restore overlay if needed
      var facetsDisclosure = document.querySelector('.mobile-facets__disclosure');
      if (facetsDisclosure && facetsDisclosure.open) {
        var overlay = document.querySelector('.product-grid-container__overlay');
        if (overlay && !overlay.classList.contains('is-active')) {
          overlay.classList.add('is-active');
        }
      }
      
      // Sync size filter active states after AJAX update
      syncSizeFilterActiveStates();
      
      // Auto-open size filter accordions that contain active selections after AJAX update
      autoOpenActiveSizeFilters();
    });
      
  });

  // Sync active states for size filters based on URL parameters
  function syncSizeFilterActiveStates() {
    var urlParams = new URLSearchParams(window.location.search);
    var activeFilters = {};
    
    // Parse URL parameters to find active size filters
    urlParams.forEach(function(value, key) {
      if (key.startsWith('filter.v.option.size_') || key.startsWith('filter.p.m.') || key.includes('size')) {
        activeFilters[key] = value.split('|'); // Handle multiple values
      }
    });
    
    // Update all size filter options
    var containers = document.querySelectorAll('#FacetsWrapperDesktop, #FacetsWrapperMobile');
    containers.forEach(function(container) {
      var sizeFilterOptions = container.querySelectorAll('.size-sub-filter-options input[type="checkbox"]');
      
      sizeFilterOptions.forEach(function(input) {
        var paramName = input.name;
        var paramValue = input.value;
        var isActive = false;
        
        // Check if this input should be active based on URL parameters
        Object.keys(activeFilters).forEach(function(filterKey) {
          if (filterKey === paramName && activeFilters[filterKey].includes(paramValue)) {
            isActive = true;
          }
        });
        
        // Update the input state
        input.checked = isActive;
        
        // Update the label classes
        var label = input.closest('label') || input.parentElement.querySelector('label');
        var textLabel = label ? label.querySelector('.facet-checkbox__text-label') : null;
        
        if (label) {
          if (isActive) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
        }
        
        if (textLabel) {
          if (isActive) {
            textLabel.classList.add('active');
          } else {
            textLabel.classList.remove('active');
          }
        }
      });
    });
  }

  // Auto-open size filter accordions that contain active selections
  function autoOpenActiveSizeFilters() {
    // Check both desktop and mobile containers
    var containers = document.querySelectorAll('#FacetsWrapperDesktop, #FacetsWrapperMobile');
    
    containers.forEach(function(container) {
      // Find all size sub-filter option lists
      var sizeSubFilterLists = container.querySelectorAll('.size-sub-filter-options');
      
      sizeSubFilterLists.forEach(function(optionsList) {
        // Check if this sub-filter contains any active options
        var activeLabels = optionsList.querySelectorAll('.facet-checkbox__text-label.active');
        var checkedInputs = optionsList.querySelectorAll('input[type="checkbox"]:checked');
        
        // Find the header for this size sub-filter
        var parentContainer = optionsList.closest('fieldset, .size-sub-filter');
        var header = parentContainer ? parentContainer.querySelector('.size-sub-filter-header') : null;
        
        if (header) {
          var plusIcon = header.querySelector('.icon-plus');
          var minusIcon = header.querySelector('.icon-minus');
          
          if (activeLabels.length > 0 || checkedInputs.length > 0) {
            // Has active selections - open the accordion
            optionsList.style.display = 'block';
            if (plusIcon) plusIcon.style.display = 'none';
            if (minusIcon) minusIcon.style.display = 'flex';
            header.classList.add('open');
          } else {
            // No active selections - close the accordion and show plus icon
            optionsList.style.display = 'none';
            if (plusIcon) plusIcon.style.display = 'flex';
            if (minusIcon) minusIcon.style.display = 'none';
            header.classList.remove('open');
          }
        }
      });
    });
  }

  // Update facets container height on window resize
  window.addEventListener('resize', updateFacetsContainerHeight);

  // Scroll to #facets-container when any [data-scroll-to-facets] element is clicked
  /*document.addEventListener('DOMContentLoaded', function() {
    var target = document.getElementById('facets-container');
    if (!target) return;
    target.addEventListener('click', function(e) {
      if (window.innerWidth >= 769) {
        var rect = target.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var offset = 150; // px
        var top = rect.top + scrollTop - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });*/

  // Force open all .mobile-facets__details on desktop when filter drawer is opened
  function openAllMobileFacetsDetails() {
    document.querySelectorAll('.mobile-facets__details').forEach(function(details) {
      details.setAttribute('open', '');
    });
  }

  // Update facets container height for positioning
  function updateFacetsContainerHeight() {
    var facetsContainer = document.getElementById('facets-container');
    if (facetsContainer) {
      var rect = facetsContainer.getBoundingClientRect();
      var height = facetsContainer.offsetHeight;
      var topPosition = rect.top + height; // Position below the container

      document.documentElement.style.setProperty('--facets-container-top', topPosition + 'px');
    }
  }

  // Listen for clicks on filter open buttons (customize selector as needed)
  document.addEventListener('click', function(e) {
    if (window.innerWidth < 769) return;

    // Example: button or link that opens the filter drawer
    if (
      e.target.matches('.mobile-facets__open, .mobile-facets__open *') ||
      e.target.closest('.mobile-facets__open')
    ) {
      /* Scroll behavior to ensure filters container is fully visible */
      var facetsContainer = document.getElementById('facets-container');
      var filtersContainer = document.querySelector('.mobile-facets__inner');
      if (facetsContainer) {
        // Wait for the filters to open before calculating scroll
        setTimeout(function() {
          var rect = facetsContainer.getBoundingClientRect();
          var filters = filtersContainer ? filtersContainer.getBoundingClientRect() : null;
          var viewportHeight = window.innerHeight;
          var containerHeight = rect.height;
          var filtersHeight = filters ? filters.height : 0;
          var containerTop = rect.top;
          var containerBottom = rect.bottom;
          var distanceToViewportBottom = viewportHeight - containerBottom;
          
          // Check if there's enough space between facets container and viewport bottom for filters
          if (distanceToViewportBottom < filtersHeight) {
            // Calculate the difference - how much more space we need
            var scrollDifference = filtersHeight - distanceToViewportBottom + 40;
            
            
            window.scrollBy({ 
              top: scrollDifference, 
              behavior: 'smooth' 
            });
          }
        }, 300); // Wait for filters animation to complete
      }
      
      // Update facets container height for positioning
      updateFacetsContainerHeight();
      
      // Add is-active class to overlay
      var overlay = document.querySelector('.product-grid-container__overlay');
      if (overlay) {
        overlay.classList.add('is-active');
      }
      setTimeout(openAllMobileFacetsDetails, 200); // Wait for drawer to open/render
      /*if (window.innerWidth >= 769) {
        document.body.style.overflow = 'hidden';
      }*/
    }
  });

  // Remove blur when mobile filters close
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.mobile-facets__disclosure').forEach(function(details) {
      details.addEventListener('toggle', function() {
        // Only handle closing, not opening
        if (!details.open) {
          // Don't remove overlay is-active class - keep it active
          document.body.style.overflow = ''; // Always reset overflow

          const mobileFacetsCloseButton = document.querySelector('.mobile-facets__close');
          if (mobileFacetsCloseButton) {
            mobileFacetsCloseButton.style.display = 'none';
          }
        } else {
          // When facets open, ensure the close button is visible and add overlay
          const mobileFacetsCloseButton = document.querySelector('.mobile-facets__close');
          if (mobileFacetsCloseButton) {
            mobileFacetsCloseButton.style.display = 'block';
          }
          
          // Add overlay when opening on desktop
          if (window.innerWidth >= 769) {
            var overlay = document.querySelector('.product-grid-container__overlay');
            if (overlay) {
              overlay.classList.add('is-active');
            }
          }
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var dropdown = document.getElementById('SortByDropdown');
    var selected = document.getElementById('SortBySelected');
    var list = document.getElementById('SortByList');
    var input = document.getElementById('SortByInput');
    var label = document.querySelector('.sortby-label-label');
    var arrow = dropdown ? dropdown.querySelector('.svg-wrapper') : null;

    if (!dropdown || !selected || !list || !input) return;

    function toggleDropdown(e) {
      e.stopPropagation();
      list.style.display = list.style.display === 'block' ? 'none' : 'block';
      dropdown.classList.toggle('open');
    }

    // Open/close dropdown on click
    selected.addEventListener('click', toggleDropdown);
    if (label) label.addEventListener('click', toggleDropdown);
    if (arrow) arrow.addEventListener('click', toggleDropdown);

    // Option click
    list.addEventListener('click', function(e) {
      if (e.target.classList.contains('custom-dropdown__option')) {
        var value = e.target.getAttribute('data-value');
        var text = e.target.textContent;
        input.value = value;
        selected.textContent = text;
        list.style.display = 'none';
        dropdown.classList.remove('open');
        input.form && input.form.submit();
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      // Only close if the click is outside the dropdown
      if (!dropdown.contains(e.target)) {
        list.style.display = 'none';
        dropdown.classList.remove('open');
      }
    });

    // Keyboard accessibility
    dropdown.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        toggleDropdown(e);
        e.preventDefault();
      }
      if (e.key === 'Escape') {
        list.style.display = 'none';
        dropdown.classList.remove('open');
      }
    });
  });

  // Close filters container when clear all filters is clicked
  document.addEventListener('click', function(e) {
    // Check if the clicked element is the clear all filters link
    if (e.target.matches('.mobile-facets__clear') || 
        e.target.closest('.mobile-facets__clear')) {
      
      // Close the mobile facets container after a short delay
      setTimeout(function() {
        var facetsDisclosure = document.querySelector('.mobile-facets__disclosure');
        if (facetsDisclosure && facetsDisclosure.open) {
          // Close the disclosure
          facetsDisclosure.removeAttribute('open');
          
          // Reset body overflow
          document.body.style.overflow = '';
          
          // Hide close button
          var mobileFacetsCloseButton = document.querySelector('.mobile-facets__close');
          if (mobileFacetsCloseButton) {
            mobileFacetsCloseButton.style.display = 'none';
          }
        }
      }, 500); // Small delay to allow the filter clearing to process first
    }
  });

})();